import React, { forwardRef } from 'react';
import './Input.css';

/**
 * Input Component
 * @param {string}  label
 * @param {string}  id
 * @param {string}  type       - text | email | number | password | date | search | ...
 * @param {string}  error      - error message
 * @param {string}  hint       - helper text
 * @param {node}    prefix     - prefix icon/text
 * @param {node}    suffix     - suffix icon/text
 * @param {boolean} required
 */
const Input = forwardRef(({
  label,
  id,
  type = 'text',
  error,
  hint,
  prefix,
  suffix,
  required = false,
  className = '',
  ...rest
}, ref) => {
  return (
    <div className={`input-group ${error ? 'input-group--error' : ''} ${className}`}>
      {label && (
        <label htmlFor={id} className="input-label">
          {label}
          {required && <span className="input-required" aria-hidden="true"> *</span>}
        </label>
      )}
      <div className={`input-wrapper ${prefix ? 'input-wrapper--prefix' : ''} ${suffix ? 'input-wrapper--suffix' : ''}`}>
        {prefix && <span className="input-prefix">{prefix}</span>}
        <input
          ref={ref}
          id={id}
          type={type}
          className="input-field"
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
          {...rest}
        />
        {suffix && <span className="input-suffix">{suffix}</span>}
      </div>
      {error && (
        <p id={`${id}-error`} className="input-error-msg" role="alert">{error}</p>
      )}
      {!error && hint && (
        <p id={`${id}-hint`} className="input-hint">{hint}</p>
      )}
    </div>
  );
});

Input.displayName = 'Input';
export default Input;
